import * as React from 'react';
import {Route} from "react-router-dom";

class PrivateRoute extends React.Component{
    render() {
        const {
            component,
            path = "/",
            exact = false,
            strict = false
        } = this.props;
        return <Route
            path={path}
            exact={exact}
            strict={strict}
            render={props => (React.cloneElement(component,{...props}))}
        />
    }
}
export default PrivateRoute;
